import React from 'react';
import PropTypes from 'prop-types';

export default function StickyOffers({ offers, onShow }) {
  return (
    <div className="offerwall-offers-sticky">
      <div className="offerwall-offers-sticky-wrapper">
        {offers.map(({ id, iconUrl, title, pointsName, pointsValue }) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            className="offerwall-offers-sticky-card"
            onClick={() => onShow(id)}
            data-testid="offer-card-sticky"
            data-ow-sdk-offer-id={id}
          >
            {iconUrl && (
              <img
                className="offerwall-offers-sticky-card-icon"
                height={92}
                src={iconUrl}
                alt={title}
              />
            )}
            <div className="offerwall-offers-sticky-card-info">
              <span
                className="offerwall-offers-sticky-card-title"
                data-testid="offer-card-sticky-title"
              >
                <b>{title}</b>
              </span>
              <span
                className="offerwall-offers-sticky-card-points js-offer-points"
                data-offer-id={id}
              >
                <b>{pointsValue}</b> {pointsName}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

StickyOffers.propTypes = {
  offers: PropTypes.any.isRequired,
  onShow: PropTypes.func.isRequired,
};
